var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllusWebMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "240px",
    height: "240px",
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illus_web_mobile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-16.1%",
    y: "-94.8%",
    width: "132.3%",
    height: "289.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.6,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 11,
    y: 0.631578947,
    width: 151,
    height: 95,
    rx: 4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "3.061617e-15%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF3FA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-43.5%",
    y: "-94.8%",
    width: "187.1%",
    height: "289.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.6,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.359375,6.71926283e-16 L45.640625,6.71926283e-16 C48.6005261,2.06040234e-15 51,2.37094424 51,5.29565217 L51,81.7043478 C51,84.6290558 48.6005261,87 45.640625,87 L7.359375,87 C4.39947392,87 2,84.6290558 2,81.7043478 L2,5.29565217 C2,2.37094424 4.39947392,5.37260132e-16 7.359375,6.71926283e-16 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-11.2%",
    y: "-4.0%",
    width: "122.4%",
    height: "112.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.290196078   0 0 0 0 0.6  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "161.517428%",
    x2: "50%",
    y2: "3.061617e-15%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF3FA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "169.495015%",
    x2: "50%",
    y2: "-23.9419243%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF3FA",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding-screen-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-520.000000, -148.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(354.000000, 148.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illus_web_mobile",
    transform: "translate(166.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    fill: "#EDF3FA",
    cx: 120,
    cy: 120,
    r: 120
  }), /*#__PURE__*/React.createElement("g", {
    id: "macbook",
    transform: "translate(32.000000, 66.368421)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "shadow",
    fillOpacity: 0.2,
    fill: "#004A99",
    filter: "url(#filter-1)",
    points: "15.64 107.864662 157 107.864662 157 83.8045113 15.64 83.8045113"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#E8EFF8",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#FFFFFF",
    strokeWidth: 1,
    x: 11.5,
    y: 1.13157895,
    width: 150,
    height: 94,
    rx: 4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.1176492,95 L169.427319,95 C169.915316,95 170.13328,95.5998974 169.915692,96.3399082 L169.233482,98.6600918 C169.013925,99.4067997 167.486728,100 167,100 L86,100 L3,100 C2.51327203,100 0.98607529,99.4067997 0.766518442,98.6600918 L0.084307679,96.3399082 C-0.13328002,95.5998974 0.0846841108,95 0.572681071,95 L85.1176492,95 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2-Copy",
    fill: "url(#linearGradient-3)",
    points: "16 6 157 6 157 91 16 91"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iphone",
    transform: "translate(132.000000, 93.368421)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "shadow",
    fillOpacity: 0.2,
    fill: "#004A99",
    filter: "url(#filter-4)",
    points: "0.62 92.2631579 52.98 92.2631579 52.98 68.2030075 0.62 68.2030075"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "url(#linearGradient-7)",
    x: 4,
    y: 9,
    width: 45,
    height: 65.0192308
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5,75.3269231 C29.1021108,75.3269231 31.2115385,77.4363507 31.2115385,80.0384615 C31.2115385,82.6405724 29.1021108,84.75 26.5,84.75 C23.8978892,84.75 21.7884615,82.6405724 21.7884615,80.0384615 C21.7884615,77.4363507 23.8978892,75.3269231 26.5,75.3269231 Z",
    id: "Rectangle-3",
    fill: "url(#linearGradient-8)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllusWebMobile);
export default __webpack_public_path__ + "static/media/illus-web-mobile.6a3333f7114485554054d61583a92052.svg";
export { ForwardRef as ReactComponent };